<template>
  <div id="existing_participant_modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">EXISTING {{ participantSingularName.toUpperCase() }} FOUND</h4>
        </div>
        <div class="modal-body">
          <form class="form-horizontal" role="form" v-on:submit.prevent="onSubmit">
            <div class="form-body">
              <div class="form-group form-md-line-input has-warning">
                <div class="col-md-12 text-center">
                  <div>
                    <h4><b>ALERT:</b> We found an existing record. Please confirm your entry or
                      select Add New
                      {{ participantSingularName }} to proceed.</h4>
                  </div>
                </div>
              </div>
              <vue-good-table
                  :columns="columns"
                  :rows="foundUsers"
                  :pagination-options="{enabled: true}"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'participant_name'">
                    <router-link v-if="props.row.organization[0].id === user.organizations[0].id"
                                 :to="{ name: 'Dashboard Participant', params: { id: props.row.id } }" tag="a"
                                 class="" data-dismiss="modal" aria-hidden="true">{{ props.row.participant_name }}
                    </router-link>
                    <span v-else>{{ props.row.participant_name }}</span>
                  </span>
                  <span v-else-if="props.column.field === 'date_completed.date'">{{ props.row.date_completed && props.row.date_completed.hasOwnProperty('date') ? props.row.date_completed.date : '' | formatDateModalNoTimeZone }}</span>
                  <span v-else-if="props.column.field === 'date_of_birth.date'">{{ props.row.date_of_birth && props.row.date_of_birth.hasOwnProperty('date') ? props.row.date_of_birth.date : '' | formatDateModalNoTimeZone }}</span>
                  <span v-else-if="props.column.field === 'organization'">{{ props.row.organization.map(item => item.name).join(',') }}</span>
                  <span v-else-if="props.column.field === 'action'">
                    <button v-if="!props.row.organization.map(item => item.id).includes(user.organizations[0].id)" class="btn btn-sm green" @click="addParticipantFromAnotherOrganization(props.row.id)">Add</button>
                  </span>
                  <span v-else>{{props.formattedRow[props.column.field]}}</span>
                </template>
              </vue-good-table>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <router-link to="/admin/participant">
            <button class="btn green" data-dismiss="modal"
                    @click.prevent="$emit('confirm')">
              <i class="fa fa-plus" aria-hidden="true"/>
              Add New {{ participantSingularName }}
            </button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import participantDisplayName from '@/mixins/participantDisplayName';

export default {
  mixins: [
    participantDisplayName
  ],
  props: {
    user: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    foundUsers: {
      type: Array,
      required: true
    }
  },
  emits: ['confirmed'],
  methods: {
    addParticipantFromAnotherOrganization(id) {
      $('#existing_participant_modal').modal('hide');
      this.$router.push({name: 'Participant Clone', params: {cloneFromId: id}});
    },
  },
  mounted() {
    $('#existing_participant_modal').modal('show').on('hidden.bs.modal', () => {
      this.$emit('hidden', false);
    });
  }
}
</script>



// WEBPACK FOOTER //
// ExistingParticipantModal.vue?4351df13